import React from 'react';
import { Drawer, DrawerProps } from '@mui/material';
import {
  MyMenuContent,
  MyMenuContentMap,
  MyMenuContentTitle,
} from '@/constant/mymenu';
import { MyMenuContentWrapper, MyMenuHeader } from './styles';
import MyPageMain, {
  MyPageMainProps,
} from '@/components/MenuDrawer/MyMenuDrawer/Main';
import useMyMenuDrawerProps, {
  MyMenuDrawerSettings,
} from '@/components/MenuDrawer/MyMenuDrawer/@hooks/useMyMenuDrawerProps';
import { MyInfo } from '@/types/api';
import { useTranslation } from 'react-i18next';
import { copyProfileCardLink } from '@/utils/function';
import { useSnackbar } from '@/hooks/global-tools';

export type MyMenuDrawerProps = {
  readonly currSub: MyMenuDrawerProps['currSubMenu'];
  readonly isOpen: DrawerProps['open'];
  readonly menuOnClose: () => void;
  readonly subMenuOnClose: () => void;
  readonly myInfo: MyInfo;
  readonly currSubMenu: null | MyMenuContent;
  readonly openSubMenu: (id: MyMenuContent) => void;
  readonly closeSubMenu: (id: MyMenuContent) => void;

  readonly mainProps: MyPageMainProps;
};

const MyMenuDrawer = (settings: MyMenuDrawerSettings) => {
  const {
    isOpen,
    menuOnClose: onClose,
    subMenuOnClose: subMenuOnClose,
    currSubMenu: isOpenSub,
    closeSubMenu: onCloseSub,
    openSubMenu,
    myInfo,
    mainProps,
  } = useMyMenuDrawerProps(settings);
  const { t } = useTranslation();
  const toast = useSnackbar();
  const handleLinkCopy = async () => {
    const resultCopy = await copyProfileCardLink(myInfo?.passportId);
    if (resultCopy) {
      toast.show({
        severity: 'success',
        message: '프로필 카드 링크가 복사되었습니다.',
        duration: 3000,
      });
    }
  };
  return (
    <Drawer
      open={isOpen}
      onClose={onClose}
      anchor={'right'}
      sx={{ '& .MuiPaper-root': { boxShadow: 'none' } }}
      slotProps={{ paper: { sx: { width: '400px' } } }}
    >
      <MyMenuHeader
        onBack={subMenuOnClose}
        onClose={onClose}
        title={t('MYPAGE.마이페이지')}
        hasBackButton={false}
        onLinkCopy={handleLinkCopy}
      />
      <MyPageMain {...mainProps} />

      {/* Sub Menu Drawer 등록 */}
      {Array.from(MyMenuContentMap.keys()).map((menuKey) => {
        const data = MyMenuContentMap.get(menuKey);

        if (!data) {
          return;
        }

        const { component: ContentComponent, hasSidePadding } = data;
        const id = menuKey;
        const isOpen = isOpenSub === menuKey;

        return (
          <Drawer
            key={id}
            id={id}
            open={isOpen}
            onClose={(event: object, reason: string) => {
              if (reason === 'backdropClick') onCloseSub(id);
              else onClose();
            }}
            anchor={'right'}
            ModalProps={{
              sx: {
                '.MuiModal-backdrop': { opacity: '0 !important' },
                '& .MuiPaper-root': { boxShadow: 'none' },
              },
            }}
            slotProps={{ paper: { sx: { width: '400px' } } }}
          >
            <MyMenuHeader
              onBack={() => onCloseSub(id)}
              onClose={onClose}
              hasBackButton={true}
              title={t(`MYPAGE.${MyMenuContentTitle[id]}`)}
            />
            <MyMenuContentWrapper hasSidePadding={hasSidePadding}>
              <ContentComponent
                myInfo={myInfo}
                menuOnClose={onClose}
                openSubMenu={openSubMenu}
              />
            </MyMenuContentWrapper>
          </Drawer>
        );
      })}
    </Drawer>
  );
};

export default MyMenuDrawer;
